import { toIndexRoute } from '@/utils/util';
import { mapState, mapMutations, mapActions } from 'vuex';
import { saveState } from '@/utils/loginStatePersist';

export default {
  computed: {
    ...mapState('user', ['menuList']),
  },
  methods: {
    ...mapMutations(['updateState']),
    ...mapActions('user', ['getUserInfo', 'getUserPermission']),
    async login(res) {
      if (res) {
        this.updateState({
          token: res.access_token,
        });
        this.getUserInfo();
        const isHasPermission = await this.getUserPermission();
        saveState();
        if (isHasPermission) {
          toIndexRoute(this.menuList, this.$router);
          this.$Message.success({
            content: '登录成功!',
          });
        } else {
          this.$Message.error({
            content: '您的账号暂未激活，请联系管理员激活账号',
          });
        }
      } else {
        this.getValidationCode();
      }
    },
  },
};
